import { render } from "./Breadcrumb.vue?vue&type=template&id=4db01b56&scoped=true&ts=true"
import script from "./Breadcrumb.ts?vue&type=script&lang=ts&external"
export * from "./Breadcrumb.ts?vue&type=script&lang=ts&external"

import "./Breadcrumb.scss?vue&type=style&index=0&id=4db01b56&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db01b56"]])

export default __exports__